export default __webpack_public_path__ + "static/media/NTORQ 125 RACE EDITION_2.5b831f1b.webp";